import { render, staticRenderFns } from "./HamburgerBtn.vue?vue&type=template&id=065e6318&scoped=true"
import script from "./HamburgerBtn.vue?vue&type=script&lang=js"
export * from "./HamburgerBtn.vue?vue&type=script&lang=js"
import style0 from "./HamburgerBtn.vue?vue&type=style&index=0&id=065e6318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065e6318",
  null
  
)

export default component.exports